// extracted by mini-css-extract-plugin
export var grid = "fp-_t";
export var gridWithRowGap = "fp--t";
export var maxWidthContainer = "fp-3t";
export var mt0 = "fp-St";
export var mt1 = "fp-Tt";
export var mt2 = "fp-Ut";
export var mt3 = "fp-Vt";
export var mt4 = "fp-Wt";
export var mt5 = "fp-Xt";
export var mt6 = "fp-Yt";
export var removeVisuallyHidden = "fp-1t";
export var video = "fp-4t";
export var videoPortrait = "fp-5t";
export var video__button = "fp-Zt";
export var video__caption = "fp-7t";
export var video__captionWrapper = "fp-6t";
export var video__icon = "fp-cu";
export var video__player = "fp-9t";
export var video__playerInline = "fp-bu";
export var video__playerPortrait = "fp-au";
export var video__thumbnail = "fp-8t";
export var visuallyHidden = "fp-0t";
export var widgetBase = "fp-2t";